<template>
  <div>
    	<div id="Ocean"></div>
  </div>
</template>

<script>
import * as THREE from 'three';
import * as Stats from 'stats.js'
import * as dat from 'dat.gui';

import { Water } from 'three/examples/jsm/objects/Water';
import { Sky } from 'three/examples/jsm/objects/Sky';

import { FirstPersonControls } from '../assets/scripts/jsm/controls/FirstPersonControls.js';
import {ImprovedNoise} from '../assets/scripts/jsm/math/ImprovedNoise.js';

import normalsTexture from  '../assets/textures/waternormals.jpg'
export default {
   	components: {},
		data: () => ({	
		}),
		mounted(){
			vueApp=this
			init()
		},
		computed:{
			isTester(){
				return this.$store.getters.getIsTester
			},
		},
		beforeDestroy(){
			running=false
			if ( gui ) gui.destroy();
		}
	};
	var vueApp
	var running=false
	var container, stats;
	var camera, scene, renderer, light ;
	var controls, water;
	
    var gui
  
	var mesh,texture, worldWidth = 1024, worldDepth = 1024,
		  worldHalfWidth = worldWidth / 2, worldHalfDepth = worldDepth / 2;
    var clock = new THREE.Clock();
    var offsets
	
	function init() {
        container = document.getElementById( 'Ocean' );
		//
		renderer = new THREE.WebGLRenderer();
		renderer.setPixelRatio( window.devicePixelRatio );
		renderer.setSize( window.innerWidth, window.innerHeight );
		container.appendChild( renderer.domElement );
		//
		scene = new THREE.Scene();
        //
        scene.fog = new THREE.FogExp2( 0x226666, 0.0005);
		//
		camera = new THREE.PerspectiveCamera( 55, window.innerWidth / window.innerHeight, 1, 20000 );
		camera.position.set( 30, 30, 100 );
		//
        var Alight = new THREE.AmbientLight( 0x101010 ); // soft white light
        scene.add( Alight );
 
		light = new THREE.DirectionalLight( 0xffffff, 0.8 );
		scene.add( light );

		// Water
		var waterGeometry = new THREE.PlaneBufferGeometry( 20000, 20000 );
		water = new Water(
			waterGeometry,
			{
				textureWidth: 1024,
				textureHeight: 1024,
				waterNormals: new THREE.TextureLoader().load( normalsTexture, function ( texture ) {
					
					texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
				} ),
				alpha: 1.0,
				sunDirection: light.position.clone().normalize(),
				sunColor: 0xffffff,
				waterColor: 0x001e0f,
				distortionScale: 3.7,
				fog: scene.fog !== undefined,
				side: THREE.DoubleSide
			}
		);
		water.rotation.x = - Math.PI / 2;
		scene.add( water );

       
		
		
		
		// Skybox

		var sky = new Sky();
		sky.scale.setScalar( 10000 );
		scene.add( sky );

		var uniforms = sky.material.uniforms;

		uniforms[ "turbidity" ].value = 10;
		uniforms[ "rayleigh" ].value = 2;
		uniforms[ "luminance" ].value = 1;
		uniforms[ "mieCoefficient" ].value = 0.005;
		uniforms[ "mieDirectionalG" ].value = 0.8;

		var parameters = {
			distance: 400,
			inclination: 0.49,
          	azimuth: 0.205,
          	rayleigh: 2
		};

		var cubeCamera = new THREE.CubeCamera( 1, 20000, 256 );
		cubeCamera.renderTarget.texture.generateMipmaps = true;
		cubeCamera.renderTarget.texture.minFilter = THREE.LinearMipMapLinearFilter;

		function updateSun() {
			var theta = Math.PI * ( parameters.inclination - 0.5 );
			var phi = 2 * Math.PI * ( parameters.azimuth - 0.5 );
			light.position.x = parameters.distance * Math.cos( phi );
			light.position.y = parameters.distance * Math.sin( phi ) * Math.sin( theta );
			light.position.z = parameters.distance * Math.sin( phi ) * Math.cos( theta );
          	sky.material.uniforms[ "rayleigh"].value=parameters.rayleigh
			sky.material.uniforms[ "sunPosition" ].value = light.position.copy( light.position );
			water.material.uniforms[ "sunDirection" ].value.copy( light.position ).normalize();
			cubeCamera.update( renderer, scene );
		}
		
        
        function lookAt(){
          	camera.lookAt( controls.target );
        }
        function updateCam(){
          if(camera.position.y<.3){
             scene.fog = new THREE.FogExp2( 0x0066, 0.01 );
          }else{
             scene.fog = new THREE.FogExp2( 0xffffff,0 );
          }
        }
        // 
       

        //
        function generateTexture( data, width, height ) {

				var canvas, canvasScaled, context, image, imageData, vector3, sun, shade;

				vector3 = new THREE.Vector3( 0, 0, 0 );

				sun = new THREE.Vector3( 1, 1, 1 );
				sun.normalize();

				canvas = document.createElement( 'canvas' );
				canvas.width = width;
				canvas.height = height;

				context = canvas.getContext( '2d' );
				context.fillStyle = '#000';
				context.fillRect( 0, 0, width, height );

				image = context.getImageData( 0, 0, canvas.width, canvas.height );
				imageData = image.data;

				for ( var i = 0, j = 0, l = imageData.length; i < l; i += 4, j ++ ) {

					vector3.x = data[ j - 2 ] - data[ j + 2 ];
					vector3.y = 2;
					vector3.z = data[ j - width * 2 ] - data[ j + width * 2 ];
					vector3.normalize();

					shade = vector3.dot( sun );

					imageData[ i ] = ( 96 + shade * 128 ) * ( 0.5 + data[ j ] * 0.007 );
					imageData[ i + 1 ] = ( 32 + shade * 96 ) * ( 0.5 + data[ j ] * 0.007 );
					imageData[ i + 2 ] = ( shade * 96 ) * ( 0.5 + data[ j ] * 0.007 );

				}

				context.putImageData( image, 0, 0 );

				// Scaled 4x

				canvasScaled = document.createElement( 'canvas' );
				canvasScaled.width = width * 4;
				canvasScaled.height = height * 4;

				context = canvasScaled.getContext( '2d' );
				context.scale( 4, 4 );
				context.drawImage( canvas, 0, 0 );

				image = context.getImageData( 0, 0, canvasScaled.width, canvasScaled.height );
				imageData = image.data;

				for ( var i = 0, l = imageData.length; i < l; i += 4 ) {

					var v = ~ ~ ( Math.random() * 5 );

					imageData[ i ] += v;
					imageData[ i + 1 ] += v;
					imageData[ i + 2 ] += v;

				}

				context.putImageData( image, 0, 0 );

				return canvasScaled;

			}
       
        //
		updateSun();

		//Controlls
		controls = new FirstPersonControls( camera, renderer.domElement );
		controls.movementSpeed = 100;
		controls.lookSpeed = 0//0.05;

		//Stats
		stats = new Stats();
		container.appendChild( stats.dom );

	
		// GUI
		if(vuuApp){
		createGUI()
		}
		
	
	//End of INIT
	
	
	function createGUI(){
		// GUI
		alert("CERATE GUI")
		console.log(gui)
		if ( gui ) {
			 try{
				gui.destroy();
			}
			catch(err){
			}	
		}
		gui = new dat.GUI();

		var folder = gui.addFolder( 'Sky' );
		folder.add( parameters, 'inclination', 0, 0.5, 0.0001 ).onChange( updateSun );
		folder.add( parameters, 'azimuth', 0, 1, 0.0001 ).onChange( updateSun );
		folder.add( parameters, 'rayleigh', 0, 2, 0.0001 ).onChange( updateSun );
		folder.open();

		var uniforms = water.material.uniforms;
		var folder = gui.addFolder( 'Water' );
		folder.add( uniforms.distortionScale, 'value', 0, 8, 0.1 ).name( 'distortionScale' );
		folder.add( uniforms.size, 'value', 0.1, 10, 0.1 ).name( 'size' );
		folder.add( uniforms.alpha, 'value', 0.9, 1, .001 ).name( 'alpha' );
		folder.open();
 
		var folder = gui.addFolder( 'Light' );
		folder.add( Alight, 'intensity', 0, 10, .5 ).name( 'Ambient Light' );
		//folder.add( camTarget, 'y', -150, 50, 0.1 ).onChange( lookAt).name( 'target' );
		folder.open();
		//
	}

	

	
       
	
	window.addEventListener( 'resize', onWindowResize, false );
		if(!running){
			running=true
			animate();
		}	
	}

	function onWindowResize() {
		camera.aspect = window.innerWidth / window.innerHeight;
		camera.updateProjectionMatrix();
		renderer.setSize( window.innerWidth, window.innerHeight );
	}
	
	function animate() {
		if(running){
			console.log("OCEAN")
			requestAnimationFrame( animate );
			render();
			stats.update();
		}
		
	}
	
	function render() {
        
		var time = performance.now() * 0.001;
		var deltaTime=clock.getDelta()
		
		
		water.material.uniforms[ "time" ].value += 1.0 / 60.0;
        controls.update( deltaTime );
      
       
		renderer.render( scene, camera );
	}

</script>


<style scoped>

</style>